/**
 * Centralized token storage utility.
 *
 * All localStorage access for the auth token goes through this module.
 * This prevents bugs where one call-site forgets to clear the token
 * during logout, and makes it trivial to swap the storage backend
 * (e.g. to sessionStorage or an HttpOnly cookie) in one place.
 */

const TOKEN_KEY = "token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);

export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
